<script>
import { distributedSeries } from "@/views/charts/data-chartist";
import BarChart from "@/views/charts/chartjs/BarChart.vue";
import { pieChart } from "@/views/charts/data-apex";
import moment from "moment";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import hotelService from "@/helpers/APIService/hotel.service";
import { getToken, onMessage } from "firebase/messaging";
import PageHeader from "@/components/page-header";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Middleware from "@/helpers/middlewares";
import { messaging } from "../firebase";
import appConfig from "@/app.config";

// Dashboard Component

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    BarChart,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      title: "Dashboard",
      dashboardData: "",
      pieChart: pieChart,
      distributedSeries: distributedSeries,
    };
  },
  mounted() {
    this.getNotificationPermission();
    this.getLatNightAuditData();
  },
  methods: {
    // Method is use for get last night audit data
    async getLatNightAuditData() {
      if (localStorage.last_audit) {
        const businessDate = localStorage.getItem("last_audit");
        this.getDashboardList(
          `?business_month=${moment(
            businessDate
          ).month()}&business_year=${moment(businessDate).year()}`
        );
      } else {
        this.getDashboardList(
          `?business_month=${moment().month()}&business_year=${moment().year()}`
        );
      }
    },
    // Method is used to get dashboard data list
    getDashboardList(filter_data) {
      hotelService
        .getDashboard(filter_data)
        .then((response) => {
          this.dashboardData = response;
          this.distributedSeries.data.series = [];

          Object.keys(response.occupancy_week_per_day).map((item) => {
            this.distributedSeries.data.series.push(
              response.occupancy_week_per_day[item]
            );
          });
          this.pieChart.series = [];
          this.pieChart.chartOptions.labels = [];
          Object.keys(response.booking_source_percentages).map((item) => {
            this.pieChart.chartOptions.labels.push(item);
            this.pieChart.series.push(
              response.booking_source_percentages[item]
            );
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle notification permission
    async getNotificationPermission() {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        // Get Token
        const token = await getToken(messaging, {
          vapidKey:
            "BNCiz9zhQIDvkKGlRMYJK_RDNI168CofFOLM-nCSzVaI9Z1zOYskjaEH3u7ZuWIVjqLts8kP0zujmOb1dGCrcK0",
        });
        if (token) {
          this.checkFCMToken(token);
        }
        onMessage(messaging, (payload) => {
          new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: payload.notification.icon,
          });
        });
      } else if (permission == "denied") {
        Middleware.notification(
          "You have denied notification permission !!",
          "info"
        );
      } else {
        console.log("Something is wrong in notification permission !!");
      }
    },
    // Method is used to check FCM token and add token
    checkFCMToken(token) {
      UserService.getUserFCMToken(`?type=web&registration_id=${token}&active=1`)
        .then((response) => {
          if (response.length == 0) {
            UserService.addUserFCMToken({
              registration_id: token,
              type: "web",
              device_id: "",
              name: this.user.user.first_name + " " + this.user.user.last_name,
              active: 1,
            })
              .then()
              .catch((error) => {
                console.log(error);
                errorHandler(error);
              });
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-xxl-4 col-xl-6 col-md-12">
        <div class="rounded dashboard-card card p-3 mb-3">
          <h4 class="font-size-18 text-center">Daily Occupancy</h4>
          <chartist
            ratio="ct-chart"
            :data="distributedSeries.data"
            :options="distributedSeries.options"
            type="Bar"
          ></chartist>
        </div>
      </div>
      <div class="col-xxl-4 col-xl-6 col-md-12">
        <div class="rounded dashboard-card card p-3 mb-3">
          <apexchart
            class="apex-charts"
            height="360"
            type="pie"
            dir="ltr"
            :series="pieChart.series"
            :options="pieChart.chartOptions"
          ></apexchart>
        </div>
      </div>
      <div class="col-xxl-4 col-md-12">
        <div class="rounded dashboard-card card p-3 mb-3">
          <h4 class="font-size-18 text-center">Daily Revenue</h4>
          <BarChart :height="300" />
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Occupancy Today</h4>
            <div class="position-relative my-5">
              <div class="d-flex align-items-center">
                <div class="range-slide-box bg-danger bg-gradient"></div>
                <div class="range-slide-box bg-warning bg-gradient"></div>
                <div class="range-slide-box bg-info bg-gradient"></div>
                <div class="range-slide-box bg-success bg-gradient"></div>
              </div>
              <div
                class="occupancy-test bg-secondary bg-gradient rounded"
                :style="`left:${
                  dashboardData.booking
                    ? dashboardData.booking.occupancy_percentage > 100
                      ? 100
                      : dashboardData.booking.occupancy_percentage
                    : 0
                }%; transform: translateX(-${
                  dashboardData.booking
                    ? dashboardData.booking.occupancy_percentage > 100
                      ? 100
                      : dashboardData.booking.occupancy_percentage
                    : 0
                }%)`"
              >
                <h5 class="text-light mb-0">
                  {{
                    dashboardData.booking
                      ? dashboardData.booking.occupancy_percentage > 100
                        ? 100
                        : dashboardData.booking.occupancy_percentage
                      : 0
                  }}%
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Guest Checked-in</h4>
            <div>
              <img src="@/assets/images/checkin.jpg" alt="" class="my-2" />
              <h4 class="">
                <span>{{
                  dashboardData.booking
                    ? dashboardData.booking.complete_checked_in
                    : "0"
                }}</span>
                of
                <span>{{
                  dashboardData.booking ? dashboardData.booking.checked_in : "0"
                }}</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Guest Checked-out</h4>
            <div>
              <img
                src="@/assets/images/checkin.jpg"
                alt=""
                class="my-2"
                style="transform: scaleX(-1)"
              />
              <h4 class="">
                <span>{{
                  dashboardData.booking
                    ? dashboardData.booking.complete_checked_out
                    : "0"
                }}</span>
                of
                <span>{{
                  dashboardData.booking
                    ? dashboardData.booking.checked_out
                    : "0"
                }}</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Stayover Guests</h4>
            <div class="my-4">
              <i class="fas fa-bed display-4 text-dark"></i>
              <h4 class="mt-3">
                {{
                  dashboardData.booking ? dashboardData.booking.stay_over : "0"
                }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">
              Total Guest Request ({{
                dashboardData.upsell_order_request
                  ? dashboardData.upsell_order_request.pending +
                    dashboardData.upsell_order_request.approved +
                    dashboardData.upsell_order_request.rejected +
                    dashboardData.upsell_order_request.void
                  : "0"
              }})
            </h4>
            <div class="my-4">
              <div class="row">
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-warning"></i>
                  <h5 class="my-3">Pending</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.upsell_order_request
                        ? dashboardData.upsell_order_request.pending
                        : "0"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-success"></i>
                  <h5 class="my-3">Approved</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.upsell_order_request
                        ? dashboardData.upsell_order_request.approved
                        : "-"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-danger"></i>
                  <h5 class="my-3">Rejected</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.upsell_order_request
                        ? dashboardData.upsell_order_request.rejected
                        : "0"
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Housekeeping Board</h4>
            <div class="my-4">
              <div class="row">
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-warning"></i>
                  <h5 class="my-3">Dirty</h5>
                  <h5 class="mb-0">10</h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-success"></i>
                  <h5 class="my-3">Cleaning</h5>
                  <h5 class="mb-0">5</h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-danger"></i>
                  <h5 class="my-3">Ready</h5>
                  <h5 class="mb-0">5</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Maintenance Task</h4>
            <div class="my-4">
              <div class="row">
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-warning"></i>
                  <h5 class="my-3">Pending</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.maintenance_ticket
                        ? dashboardData.maintenance_ticket.pending
                        : "0"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-success"></i>
                  <h5 class="my-3">InProgress</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.maintenance_ticket
                        ? dashboardData.maintenance_ticket.in_progress
                        : "0"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <i class="mdi mdi-circle fs-5 text-danger"></i>
                  <h5 class="my-3">Done</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.maintenance_ticket
                        ? dashboardData.maintenance_ticket.completed
                        : "0"
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-6">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">
              Guest Key Issued Today ({{
                dashboardData.guest_iot_key
                  ? dashboardData.guest_iot_key.rfid +
                    dashboardData.guest_iot_key.mobile +
                    dashboardData.guest_iot_key.key_code
                  : "0"
              }})
            </h4>
            <div class="my-4">
              <div class="row">
                <div class="col">
                  <h5 class="my-4">RFID</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.guest_iot_key
                        ? dashboardData.guest_iot_key.rfid
                        : "0"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <h5 class="my-4">Mobile Key</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.guest_iot_key
                        ? dashboardData.guest_iot_key.mobile
                        : "0"
                    }}
                  </h5>
                </div>
                <div class="col">
                  <h5 class="my-4">KEY CODE</h5>
                  <h5 class="mb-0">
                    {{
                      dashboardData.guest_iot_key
                        ? dashboardData.guest_iot_key.key_code
                        : "0"
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-12">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Communication Stats</h4>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-phone-alt text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Incoming</h5>
                  <P class="font-size-16 mb-0">1</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-warning bg-soft rounded-pill">
                    <i class="fas fa-phone-alt text-warning fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Outgoing</h5>
                  <P class="font-size-16 mb-0">0</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-danger bg-soft rounded-pill">
                    <i class="mdi mdi-phone-missed text-danger fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Missed</h5>
                  <P class="font-size-16 mb-0">5</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-paper-plane text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">911 Calls</h5>
                  <P class="font-size-16 mb-0">5</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-info bg-soft rounded-pill">
                    <i class="bx bxs-alarm text-info fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Wakeup Calls</h5>
                  <P class="font-size-16 mb-0">5</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-secondary bg-soft rounded-pill">
                    <i class="mdi mdi-email text-secondary fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">SMS</h5>
                  <P class="font-size-16 mb-0">5</P>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-12">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Device Online Status</h4>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col">
                  <div class="dashboard-icon bg-dark bg-soft rounded-pill">
                    <i class="mdi mdi-lock text-dark fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Locks</h5>
                  <p class="font-size-16 mb-0">9 of 10</p>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-warning bg-soft rounded-pill">
                    <i class="fas fa-lightbulb text-warning fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Lights</h5>
                  <p class="font-size-16 mb-0">5 of 10</p>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-info bg-soft rounded-pill">
                    <i class="fas fa-snowflake text-info fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">HVAC</h5>
                  <p class="font-size-16 mb-0">5 of 10</p>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-lungs-virus text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Air-Q</h5>
                  <P class="font-size-16 mb-0">Good</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-secondary bg-soft rounded-pill">
                    <i class="fas fa-wifi text-secondary fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Wi-Fi</h5>
                  <P class="font-size-16 mb-0">5 of 5</P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-danger bg-soft rounded-pill">
                    <i class="mdi mdi-phone-classic text-danger fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Phones</h5>
                  <P class="font-size-16 mb-0">50 of 50</P>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12" v-if="dashboardData.message">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Chat Message</h4>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-check text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Delivered</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.chat.delivered }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-warning bg-soft rounded-pill">
                    <i class="fas fa-check-double text-warning fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Read</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.chat.read }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-danger bg-soft rounded-pill">
                    <i class="fab fa-get-pocket text-danger fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Received</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.chat.received }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-paper-plane text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Sent</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.chat.sent }}
                  </P>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12" v-if="dashboardData.message">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">SMS Message</h4>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-check text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Delivered</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.sms.delivered }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-warning bg-soft rounded-pill">
                    <i class="fas fa-check-double text-warning fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Read</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.sms.read }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-danger bg-soft rounded-pill">
                    <i class="fab fa-get-pocket text-danger fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Received</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.sms.received }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-paper-plane text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Sent</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.sms.sent }}
                  </P>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12" v-if="dashboardData.message">
        <div class="rounded dashboard-card card p-3 mb-3">
          <div class="text-center">
            <h4 class="font-size-18">Whatsapp Message</h4>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-check text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Delivered</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.whatsapp.delivered }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-warning bg-soft rounded-pill">
                    <i class="fas fa-check-double text-warning fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Read</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.whatsapp.read }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-danger bg-soft rounded-pill">
                    <i class="fab fa-get-pocket text-danger fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Received</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.whatsapp.received }}
                  </P>
                </div>
                <div class="col">
                  <div class="dashboard-icon bg-success bg-soft rounded-pill">
                    <i class="fas fa-paper-plane text-success fs-2 lh-1"></i>
                  </div>
                  <h5 class="mb-2 font-weight-semibold">Sent</h5>
                  <P class="font-size-16 mb-0">
                    {{ dashboardData.message.whatsapp.sent }}
                  </P>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.range-slide-box {
  width: 25%;
  height: 30px;
}
.range-slide-box:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.range-slide-box:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.occupancy-test {
  position: absolute;
  top: -10px;
  transition: all 0.5s ease-in-out;
  display: inline-flex;
  padding: 16px;
  background-color: #ffffffbf;
}
.dashboard-card {
  min-height: 196px;
}
.dashboard-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
